




import {Component, Prop, Vue} from "vue-property-decorator";
import {CountryStore} from "@/modules/regionsv2/country/store";

@Component({
    name: "CountryLabelV2"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly id!: number;

    get label() {
        return CountryStore.data[this.id]?.name;
    }
}
